<!-- About Start -->
<div class="container-xxl about " style=" background: linear-gradient(rgba(0, 0, 0, .1), rgba(0, 0, 0, .1)), url(assets/img/a.svg) left center no-repeat;
                        background-size: cover;">
    <div class="container">
        <div class="row g-0">
            <div class="col-lg-6">
                <div class="h-100 d-flex align-items-center justify-content-center" style="min-height: 300px;">
                    <h1 style="color: white; font-size: 56px !important;">Qui sommes nous? </h1>
                </div>
            </div>
            <div class="col-lg-6 pt-lg-2 mb-lg-2 wow fadeIn" data-wow-delay="0.5s">
                <div class="bg-white rounded-top p-3 mt-lg-5 pt-3">
                    <p style="font-size: 15px; text-align: justify;">Créé il y a plus de 18ans, <b> TALENTS PLUS
                            AFRIQUE </b>
                        vous accompagne dans vos enjeux RH : <b>Travail temporaire, Assistance aux entreprises,
                            Formation
                            (Intra et Inter entreprise, Individuelle, E-learning, Coaching), Conseils aux PME/PMI,
                            Etudes RH
                            générale
                            et SIRH </b> à
                        l’international au travers de 05 filiales implantées dans 04 pays.</p>

                    <a class="btn  rounded-pill py-3 px-5" style="background-color: #FF5A00; color: white;"
                        href="contact/benin-tpc">Contactez
                        nous</a>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- About End -->
<!-- About End -->
<section class="ett" style="margin:30px auto;">
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-7 col-lg-7 order-1" style="margin: auto;">
                <div>
                    <p class="section-title" style="    font-size: 30px !important;">Le mot du Directeur Général</p>

                    <p style="text-align: justify;">Déjà plus de 18 ans que nous nous sommes engagés à vous servir !
                        Engagement de la qualité au service d’une plus grande compétitivité de vos entreprises, de vos
                        organisations.
                        Plus de 18 ans passés à créer de la passion et l’énergie partout où nous intervenons et à viser
                        constamment
                        l’excellence.

                        Aujourd’hui, pour vous, nous sommes une marque de référence.
                        Notre philosophie première est d’apporter un plus à la valorisation des talents et à la
                        professionnalisation de votre
                        structure.
                        Un Groupe composé d’une équipe pluridisciplinaire investie de la croyance forte que l’Afrique et
                        les Africains peuvent
                        offrir un service d’expertise et de qualité à la dimension internationale.
                        Nous avons la conviction que les organisations et les entreprises peuvent réaliser de belles
                        choses si elles étaient
                        soutenues, si elles avaient l’organisation, la culture, les compétences techniques, les
                        compétences
                        managériales et le leadership approprié.
                    </p>
                    <p style="font-weight: bold;">Avec vous, nous affinons notre expertise.</p>
                    <h3>Alfred BIAOU</h3>
                </div>
            </div>
            <div class="col-12 col-sm-5 col-lg-5 order-2" style="margin: auto; display: flex;
    justify-content: space-around;"><img style="    width: 55%;    border-radius: 10%;margin-top: -8px; "
                    src="assets/img/dg.jpg"></div>
        </div>
    </div>
</section>
<section
    style="padding: 20px 0px 10px; background: url('assets/img/back-about.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-sm-4 col-lg-4" style="display: flex;
    flex-direction: row;
    align-items: center;">
                <h2 class="implantation" style="color: #00027D; font-weight: bold;font-size: 25px !important;">Nos
                    engagements</h2>

            </div>
            <div class="col-12 col-sm-4 col-lg-4">
                <div class="about-pays">
                    <ul>
                        <li class="" style=" font-weight: bold;"><i class="fa fa-hand-o-right mr-2 "
                                aria-hidden="true"></i>Efficacité</li>
                        <li style=" font-weight: bold;"><i class="fa fa-hand-o-right mr-2"
                                aria-hidden="true"></i>Exigence
                        </li>
                        <li style=" font-weight: bold;"><i class="fa fa-hand-o-right mr-2" aria-hidden="true"></i>Equité
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-12 col-sm-4 col-lg-4">

                <ul>
                    <li style=" font-weight: bold;"><i class="fa fa-hand-o-right mr-2" aria-hidden="true"></i>Ethique
                    </li>
                    <li style=" font-weight: bold;"><i class="fa fa-hand-o-right mr-2" aria-hidden="true"></i>Agilité
                    </li>
                    <li style=" font-weight: bold;"><i class="fa fa-hand-o-right mr-2"
                            aria-hidden="true"></i>Bienveillance</li>

                </ul>
            </div>
        </div>
    </div>
</section>
<section class="testimonials"
    style="padding: 10px 0px 10px; background: url('assets/img/back-pays.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
    <div class="container p-3">
        <h2 class="customize-title mb-3 text-white" style="text-align: center !important;">Nos certifications et
            agréments</h2>
        <div class="row">
            <div class="col-lg-4  col-12 col-sm-6 " style="display: flex;
    align-items: center;">
                <img src="assets/img/interteck.png" alt="">
            </div>
            <div class="col-lg-8  col-12 col-sm-6 ">
                <p class="text-justify text-white"><b>Les prestations de formations de Talents Plus Conseils Bénin ont
                        reçu la
                        certification qualité ISO
                        29993 V 2017 –
                        Qualité des organismes de formation.</b>ISO 29993 V 2017 est le gage de qualité d’un référentiel
                    rigoureux reconnu à
                    l’international. C’est
                    dorénavant, votre
                    critère objectif supplémentaire qui justifie votre préférence et votre confiance en la qualité et en
                    l’efficacité de nos
                    ateliers de formations. Cette certification des services de formations de Talents Plus Conseils est
                    délivrée par <b>INTERTEK</b></p>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-8  col-12 col-sm-6 ">
                <p class="text-justify text-white">Le Cabinet est également habilité comme Centre de Formation
                    Professionnelle Continue par le MTFP ( Ministère du Travail et de la Fonction Publique) du Bénin à
                    travers la Direction
                    Générale de Renforcement des Capacités et de l'Employabilité (DGRCE) et le Fonds de Développement de
                    la Formation Professionnelle Continue et de l'Apprentissage (FODEFCA), le FDFP (Fonds de
                    Dévéloppement de Formation Professionnelle) en Côte d'Ivoire et
                    le FAFPA (Fonds d'Appui à la Formation Professionnelle et à l'Apprentissage) au Mali.</p>
            </div>
            <div class="col-lg-4  col-12 col-sm-6 " style="display: flex;
    align-items: center;">
                <img src="assets/img/part.jpg" alt="">
            </div>
        </div>
    </div>
</section>

<section
    style="padding: 50px 0px 20px; background: url('assets/img/back-about.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-4 col-lg-4">
                <h2 class="customize-title" style="color: #00027D; font-weight: bold;">Nos implantations</h2>
                <p>Le groupe africain TALENTS PLUS AFRIQUE est composé de cinq filiales principales :
                    Avec des représentations au <span style="font-weight: bold;">Burkina Faso</span>, au <span
                        style="font-weight: bold;">Sénégal</span>, en <span style="font-weight: bold;">Guinée</span>,
                    en <span style="font-weight: bold;">Centrafrique</span> et au <span
                        style="font-weight: bold;">Tchad</span>.
                </p>
            </div>
            <div class="col-12 col-sm-4 col-lg-4">
                <div class="about-pays">
                    <h4><img src="assets/img/benin.svg">Bénin</h4>
                    <a href="/filiales/talents-plus-conseils-benin">
                        <p style="font-size: 12px;"><img src="assets/img/pin.svg">TALENTS PLUS CONSEILS BENIN</p>
                    </a>
                    <a href="/filiales/talents-plus-ett-benin">
                        <p style="font-size: 12px;"><img src="assets/img/pin.svg">TALENTS PLUS E.T.T. BENIN </p>
                    </a>
                </div>
                <div class="about-pays">
                    <h4><img src="assets/img/togo.svg">Togo</h4>
                    <a href="/filiales/talents-plus-ett-togo">
                        <p style="font-size: 12px;"><img src="assets/img/pin.svg">TALENTS PLUS E.T.T. TOGO</p>
                    </a>
                </div>
            </div>
            <div class="col-12 col-sm-4 col-lg-4">
                <div class="about-pays">
                    <h4><img src="assets/img/mali.svg">Mali</h4>
                    <a href="/filiales/talents-plus-conseils-mali">
                        <p style="font-size: 12px;"><img src="assets/img/pin.svg">TALENTS PLUS CONSEILS MALI</p>
                    </a>
                </div>
                <div class="about-pays">
                    <h4><img src="assets/img/cote.svg">Côte d’ivoire</h4>
                    <a href="/filiales/talents-plus-conseils-cote-divoire">
                        <p style="font-size: 12px;"><img src="assets/img/pin.svg">TALENTS PLUS CONSEILS Côte d’ivoire
                        </p>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>
<div id="partenaires"></div>
<section class="partenaires" style="padding: 50px 0px;">
    <div class="container">
        <H2 class="customize-title" style="text-align: center; margin-bottom: 50px; font-weight: bold;">Nos partenaires
        </H2>
        <div class="row">
            <div class="col-6 col-sm-3 col-lg-2">
                <div class="part-card">
                    <img style="width: 100%;" src="assets/img/fodeca.svg">
                </div>
            </div>

            <div class="col-6 col-xs-6 col-sm-3 col-lg-2">
                <div class="part-card">
                    <img style="width: 100%;" src="assets/img/fdfp.svg">
                    <!-- <p> FDFP – Fonds de dévéloppement de formation professionnelle</p> -->
                </div>
            </div>
            <div class="col-6 col-sm-3 col-xs-6 col-lg-2">
                <div class="part-card">
                    <img style="width: 100%;" src="assets/img/central.svg">

                </div>
            </div>
            <div class="col-6 col-sm-3 col-lg-2">
                <div class="part-card">
                    <img style="width: 50%;" src="assets/img/partenaires/epac.png">

                </div>
            </div>
            <div class="col-6 col-sm-3 col-lg-2">
                <div class="part-card">
                    <img style="width: 100%;" src="assets/img/job.svg">
                    <!-- <p> JOBSORA</p> -->
                </div>

            </div>


            <div class="col-6 col-sm-3 col-lg-2">
                <div class="part-card">
                    <img style="width: 100%;" src="assets/img/fafpa.svg">
                    <!-- <p>Fonds d'Appui à la Formation Professionnelle et à l'Apprentissage - FAFPA-Burkina</p> -->
                </div>

            </div>
        </div>
        <div class="row justify-content-center">

            <div class="col-6 col-sm-3 col-lg-2">
                <div class="part-card">
                    <img style="width: 100%;" src="assets/img/synergie.svg">
                    <!-- <p>Consult Services Synergie</p> -->
                </div>

            </div>
            <div class="col-6 col-sm-3 col-lg-2">
                <div class="part-card">
                    <img style="width: 40%;" src="assets/img/partenaires/eneam.png">
                    <!-- <p>Consult Services Synergie</p> -->
                </div>

            </div>
            <div class="col-6 col-sm-3 col-lg-2">
                <div class="part-card">
                    <img style="width: 40%;" src="assets/img/partenaires/uak.jpeg">
                    <!-- <p>Consult Services Synergie</p> -->
                </div>

            </div>

        </div>
    </div>

    <section
        style="background:url(assets/img/back-produits.svg); background-size: cover; background-position: center; background-repeat: no-repeat;">
        <div class="container">
            <app-autresites></app-autresites>
        </div>
    </section>

    <section
        style="padding: 20px 0px 10px; background: url('assets/img/back-pays.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-6 col-lg-6" style="margin: auto;">
                    <!-- <h2 style="color : #fff;">Pays où nous sommes intervenus</h2> -->
                    <h2 class="customize-title" style="color : #fff;">Pays des missions réalisées.</h2>
                </div>
                <div class="col-6 col-sm-2 col-lg-2" style="margin: auto;">
                    <p style="color: #fff;">
                        <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> BENIN
                        <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> BURKINA-FASO
                        <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> CAMEROUN
                        <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> CENTRAFRIQUE
                        <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> CÔTE D’IVOIRE
                        <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> GHANA
                    </p>
                </div>
                <div class="col-6 col-sm-2 col-lg-2" style="margin: auto;">
                    <p style="color: #fff;">

                        <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> GUINEE BISSAU
                        <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> GUINEE CONAKRY
                        <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> HAITI
                        <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> KENYA
                        <br> <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> MALI
                        <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> MAURITANIE
                    </p>
                </div>
                <div class="col-12 col-sm-2 col-lg-2" style="margin: auto;">
                    <p style="color: #fff;">
                        <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> NIGER
                        <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> NIGERIA
                        <br> <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> SENEGAL
                        <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> SIERRA-LEONE
                        <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> TCHAD
                        <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> TOGO
                    </p>
                </div>

            </div>
        </div>
    </section>

    <div id="client"></div>
    <section class="nos-clients">
        <h2 class="customize-title"
            style="text-align: center; margin-bottom: 30px; font-weight: bold; color: rgb(0, 2, 125);">Nos secteurs</h2>
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-6 col-sm-3 col-lg-2">
                    <div class=" client-hover">
                        <p class="bold">ONGs &amp; Institutions Internationales</p>

                    </div>
                </div>
                <div class="col-6 col-sm-3 col-lg-2">
                    <div class=" client-hover">
                        <p class="bold">Institutions Régionales et sous Régionales</p>

                    </div>
                </div>
                <div class="col-6 col-sm-3 col-lg-2">
                    <div class=" client-hover">
                        <p class="bold"> Bancaire &amp; Assurance</p>

                    </div>
                </div>
                <div class="col-6 col-sm-3 col-lg-2">
                    <div class=" client-hover">
                        <p class="bold">Administration publique et parapublique</p>

                    </div>
                </div>
                <div class="col-6 col-sm-3 col-lg-2">
                    <div class=" client-hover">
                        <p class="bold"> Télé- <br> communications</p>

                    </div>
                </div>
                <div class="col-6 col-sm-4 col-lg-2">
                    <div class=" client-hover">
                        <p class="bold">Energie et Hydraulique</p>

                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-6 col-sm-4 col-lg-2">
                    <div class=" client-hover">
                        <p class="bold"> Informatique</p>

                    </div>
                </div>
                <div class="col-6 col-sm-4 col-lg-2">
                    <div class=" client-hover">
                        <p class="bold"> Pétrolier et Minier</p>

                    </div>
                </div>

                <div class="col-6 col-sm-4 col-lg-2">
                    <div class=" client-hover">
                        <p class="bold">Projets</p>

                    </div>
                </div>
                <div class="col-6 col-sm-4 col-lg-2">
                    <div class=" client-hover">
                        <p class="bold">Industries</p>

                    </div>
                </div>
                <div class="col-6 col-sm-4 col-lg-2">
                    <div class=" client-hover">
                        <p class="bold" style="text-align: center;">Ports et aéroports</p>
                    </div>
                </div>
                <div class="col-6 col-sm-4 col-lg-2">
                    <div class=" client-hover">
                        <p class="bold">Hôtellerie et restauration</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div id="distinc"></div>

    <section
        style="padding: 40px 0px 0px 0px; background: url('assets/img/back-distinc.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
        <div class="container">
            <h2 class="customize-title" style="text-align: center; font-weight: bold; color: #00027D;">Nos distinctions
            </h2>

            <p style="text-align: center; margin-bottom: 50px; font-weight: bold;">Le Groupe Talents Plus se distingue
                par son engagement
                total et par la qualité de ses prestations.</p>
            <div class="row">
                <div class="col-12 col-sm-6 col-lg-3 distinction">
                    <div class="card-part" style="height: 350px;">
                        <img src="assets/img/human.svg"
                            style="  display: block;  width: 100%; height: 45%;  margin: auto;">
                        <p> <span style="font-weight:bold; color:#ff5a00 ;">CENTURY INTERNATIONAL GOLD QUALITY ERA
                                AWARD</span> en
                            2008 décerné par la Business Initiative Direction pour la qualité des prestations du Cabinet
                        </p>
                    </div>
                </div>


                <div class="col-12 col-sm-6 col-lg-3 distinction">
                    <div class="card-part" style="height: 350px;">
                        <div>
                            <img src="assets/img/century.svg"
                                style="  display: block;  width: 100%; height: 42%;  margin: auto;">
                        </div>

                        <div>
                            <p> <span style="font-weight:bold; color:#ff5a00 ;">PRIX DU MEILLEUR PRESTATAIRE DE L’ANNEE
                                    2009 </span>
                                par
                                BRISTISH AMERICAN TOBACCO, 1ère Multinationale de l’industrie du tabac dans le monde.
                            </p>
                        </div>


                    </div>
                </div>

                <div class="col-12 col-sm-6 col-lg-3 distinction">
                    <div class="card-part" style="height: 350px;">
                        <div>
                            <img src="assets/img/distinc.jpg"
                                style="  display: block;  width: 100%; height: 45%;  margin: auto;">
                        </div>

                        <p> <span style="font-weight:bold; color:#ff5a00 ;">BEST HUMAN RESSOURCES CONSULTING AGENCY,
                                WEST
                                AFRICA</span> en 2016 décerné par le Magazine CORPORATE VISION UK.</p>
                    </div>
                </div>

                <div class="col-12 col-sm-6 col-lg-3 distinction">
                    <div class="card-part" style="height: 350px;">
                        <div>
                            <img src="assets/img/distinct.jpg"
                                style="  display: block;  width: 100%; height: 45%;  margin: auto;">
                        </div>

                        <p> <span style="font-weight:bold; color:#ff5a00 ;">ENTREPRISE LA PLUS DYNAMIQUE DU SECTEUR DE
                                LA GESTION
                                DES RESSOURCES HUMAINES DU BENIN ET DE L'ESPACE UEMOA</span>
                        </p>
                    </div>
                </div>

            </div>
        </div>
    </section>
    <app-confiance></app-confiance>